<template>
	<footer id="footer">
		<div class="container">
			<div class="footer__logo">
				<img src="/images/front/svg/nauticstar-logo-white.svg" alt="logo">
			</div>
			<div class="footer__columns">
				<div class="col">
					<h4 class="col__title">{{ location?.dealer?.name }}</h4>
					<div class="address">
						{{ location.address }}</br>
						{{ location.city }}, {{ location.state }} {{ location.zip }}
					</div>
					<div class="phone" v-if="location.phone">
						<strong>Phone:</strong> <a :href="'tel:' + location.phone">{{ location.phone }}</a>
					</div>
				</div>
				<div class="col">
					<h4 class="col__title">Sales</h4>
					<ul>
						<li>
							<router-link to="/">Inventory</router-link>
						</li>
						<li>
							<a href="https://build.nauticstarboats.com/" target="_blank">Design & Build</a>
						</li>
						<li>
							<a href="https://nauticstarboats.com/contact-us/?form=request%20quote" target="_blank">Request A Quote</a>
						</li>
					</ul>
				</div>
				<div class="col">
					<h4 class="col__title">Company</h4>
					<ul>
						<li>
							<a href="https://nauticstarboats.com/about-us/" target="_blank">About Nauticstar</a>
						</li>
						<li>
							<a href="https://nauticstarboats.com/boats/" target="_blank">Boats</a>
						</li>
					</ul>
				</div>
				
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		computed: {
			location() {
				return this.$store.state.location;
			}
		}
	}
</script>